"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldValidationIcon = exports.FieldSelectArrowIcon = exports.FieldIconInset = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconDisplay = require("../icons/IconDisplay");

var _iconConst = require("../icons/iconConst");

var _fieldUtils = require("./fieldUtils");

var _fieldAttrsUtils = require("./fieldAttrsUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* Icons used inside of a field */
var FieldIconInset = function FieldIconInset(_ref) {
  var icon = _ref.icon;
  return _react.default.createElement("span", {
    className: "field-icon-inset"
  }, icon);
};

exports.FieldIconInset = FieldIconInset;
FieldIconInset.propTypes = {
  icon: _propTypes.default.node.isRequired
};
/* caret icon inside of select field */

var FieldSelectArrowIcon = function FieldSelectArrowIcon(_ref2) {
  var isInvalid = _ref2.isInvalid,
      hasTransparentBackground = _ref2.hasTransparentBackground;
  return _react.default.createElement("span", (0, _fieldAttrsUtils.selectArrowAttrs)(isInvalid, hasTransparentBackground), _iconConst.CHEVRON_DOWN);
};

exports.FieldSelectArrowIcon = FieldSelectArrowIcon;
FieldSelectArrowIcon.propTypes = {
  isInvalid: _propTypes.default.bool.isRequired,
  hasTransparentBackground: _propTypes.default.bool.isRequired
};
/* Icons used to convey field validation state */

var FieldValidationIcon = function FieldValidationIcon(_ref3) {
  var id = _ref3.id,
      validationProps = _ref3.validationProps;
  var isInvalid = validationProps.isInvalid,
      type = validationProps.type,
      showIcon = validationProps.showIcon;
  var valID = validationProps.id;
  var iconAttrs = (0, _fieldAttrsUtils.iconAttributes)({
    id: id,
    isInvalid: isInvalid
  });
  var childKey = "".concat(valID, "-").concat(type);
  return showIcon ? _react.default.createElement("span", _extends({}, iconAttrs, {
    key: childKey
  }), _react.default.createElement(_IconDisplay.Icon, {
    type: type
  })) : _react.default.createElement("span", null);
};

exports.FieldValidationIcon = FieldValidationIcon;
FieldValidationIcon.propTypes = {
  id: _propTypes.default.string.isRequired,
  validationProps: _fieldUtils.validationPropsTypes.isRequired
};